import { Button, Drawer, DrawerProps } from 'antd';
import { ReactScrollProvider } from 'views/Aide/components/ReactScrollContext';
import { PhraseContentImplement } from '../PhraseContent';
import { PhrasesRootData } from 'services/api/phrase';
import { useTranslate } from '@tolgee/react';
import styled from '@emotion/styled';

function PreviewDrawer({
  regionRange,
  phraseGroupList,
  phraseRootData,
  ...otherProps
}: DrawerProps & {
  regionRange?: General.UpperCaseRegion[];
  phraseGroupList?: Phrase.Group[];
  phraseRootData?: PhrasesRootData;
}) {
  const { t } = useTranslate();

  return (
    <Drawer
      width={1200}
      title={t('查看快捷回复')}
      footer={
        <Button type="primary" onClick={otherProps.onClose as any}>
          {t('marketing.关闭')}
        </Button>
      }
      {...otherProps}
    >
      <Container>
        <ReactScrollProvider>
          <PhraseContentImplement
            key={phraseRootData?.id}
            readonly
            routeState={{
              regionRange,
              phraseGroupList,
              phraseRootData,
            }}
            phraseRootId={phraseRootData?.id}
            platform={phraseRootData?.channel}
            action="edit"
            groupType={phraseRootData?.groupType}
            phraseGroupId={phraseRootData?.phraseGroupId}
          />
        </ReactScrollProvider>
      </Container>
    </Drawer>
  );
}

const Container = styled.div`
  height: calc(100% + 48px);
  margin: -24px;
  background: #f0f2f5;
`;

export default PreviewDrawer;
